'use strict';

(function () {
  var wpml = document.querySelectorAll('.js-wpml-ls-item-toggle');

  if (!wpml) {
    return;
  }

  var wpmlClass = function wpmlClass() {
    document.body.classList.toggle('js-wpml-is-visible');
  };

  wpml.forEach(function (el, i) {
    el.addEventListener('click', wpmlClass);

    el.addEventListener('keydown', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        wpmlClass();
        e.preventDefault();
      }
    });
  });
})();